import { config, debug, i18n, inject, observer, React, Route, RouteComponentProps, ui } from "aaa";
import { georgeWebHeaderStore } from "components/common/GeorgeWebHeader";
import { LandingPage } from "components/common/LandingPage";
import { NewAddress } from "components/common/NewAddress";
import auth from "stores/AuthStore";
import { ExternalInterfaceStore } from "stores/ExternalInterfaceStore";
import { pushRoute } from "stores/RouterFunctions";
import { NewPhone } from "../common/NewPhone";
import { CreditCardUpgradeRoutes } from "./CreditCardUpgradeRoutes";
import { CreditCardUpgradeStore } from "./CreditCardUpgradeStore";
import trackingStore from "stores/TrackingStore";
import { compact } from "lodash";
import { CreditCardUpgradePersonalData } from "./CreditCardUpgradePersonalData";
import { CreditCardUpgradeSummary } from "./CreditCardUpgradeSummary";
import { CreditCardUpgradeSigning } from "./CreditCardUpgradeSigning";
import { CreditCardUpgradeSuccess } from "./CreditCardUpgradeSuccess";
import { CreditCardUpgradeNotPossibleError } from "./CreditCardUpgradeNotPossibleError";
import { PdfViewer } from "components/common/PdfViewer";

type IProps = RouteComponentProps & i18n.InjectedIntlProps & {
    externalInterfaceStore: ExternalInterfaceStore;
};

@i18n.injectIntl
@inject("externalInterfaceStore")
@observer
export default class CreditCardUpgradeContainer extends React.Component<IProps> {
    store: CreditCardUpgradeStore;

    constructor(props: IProps) {
        super(props);
        this.store = new CreditCardUpgradeStore();
    }

    async componentDidMount() {
        pushRoute(CreditCardUpgradeRoutes.ROOT);
        try {
            georgeWebHeaderStore.configure({
                title: ui.__("creditCardUpgrade.document.title"),
            });

            if (auth.authorized) {
                await this.store.loadData();

                if (this.store.upgradeDetails?.upgradeStatus !== "OPEN") {
                    pushRoute(CreditCardUpgradeRoutes.ERROR_UPGRADE_NOT_POSSIBLE);
                }
            }
        } catch (error) {
            debug.log("### CreditCardUpgradeContainer.componentDidMount() Failed to load data", error);

            if (!config.DEBUG) {
                pushRoute("/error");
            }
        }
    }

    withStore(Component: any) {
        return () => <Component {...this.props} store={this.store} />;
    }

    withContactsStore(Component: any) {
        return () => <Component {...this.props} contactsStore={this.store.contactsStore} />;
    }

    render() {
        document.title = ui.__("creditCardUpgrade.document.title");

        // has to be put into a const here in order to make observing work and rerender
        const upgradeFromChannelProduct = this.store.upgradeDetails?.card?.productCode;
        const upgradeToChannelProduct = this.store.upgradeDetails?.offer?.channelProduct;

        return (
            <div>
                <Route
                    exact
                    path={CreditCardUpgradeRoutes.ROOT}
                    render={() => (
                        <LandingPage
                            useWebVersion
                            type="PRODUCT"
                            code={upgradeToChannelProduct}
                            codeSuffix="UPGRADE"
                            comparisonCodes={compact([
                                upgradeFromChannelProduct ?? undefined,
                                upgradeToChannelProduct ? `${upgradeToChannelProduct}_UPGRADE` : undefined
                            ])}
                            store={this.store}
                            onClickButton={async () => {
                                await trackingStore.trackEvent({ eventName: "upgradeNow" });
                                pushRoute(CreditCardUpgradeRoutes.PERSONAL_DATA);
                            }}
                        />
                    )}
                />
                <Route exact path={CreditCardUpgradeRoutes.PERSONAL_DATA} component={this.withStore(CreditCardUpgradePersonalData)} />
                <Route exact path={CreditCardUpgradeRoutes.SUMMARY} component={this.withStore(CreditCardUpgradeSummary)} />
                <Route exact path={CreditCardUpgradeRoutes.SIGNING} component={this.withStore(CreditCardUpgradeSigning)} />
                <Route exact path={CreditCardUpgradeRoutes.SUCCESS} component={this.withStore(CreditCardUpgradeSuccess)} />
                <Route exact path={CreditCardUpgradeRoutes.NEW_PHONE} component={this.withContactsStore(NewPhone)} />
                <Route exact path={CreditCardUpgradeRoutes.NEW_ADDRESS} component={this.withContactsStore(NewAddress)} />
                <Route exact path={CreditCardUpgradeRoutes.ERROR_UPGRADE_NOT_POSSIBLE} component={CreditCardUpgradeNotPossibleError} />
                <Route path={CreditCardUpgradeRoutes.PDF} component={() => <PdfViewer {...this.props} uint8Data={this.store.pdfData} />} />
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/creditCardUpgrade/CreditCardUpgradeContainer.tsx